import { useTranslation } from "@opendash/i18n";
import { Form, InputNumber } from "antd";
import React from "react";
import FormItemProps from "../../../types/FormItemProps";

export default (props: FormItemProps) => {
  const t = useTranslation();

  return (
    <Form.Item
      label={t("maintenance:items.create.form.price.label")}
      name="price"
      initialValue={props.editItem?.price}
    >
      <InputNumber prefix={"€"} style={{ width: "100%" }} />
    </Form.Item>
  );
};
